<template>
    <rkm-form
        ref="RkmForm"
    >
        <rkm-row>
            <rkm-col
                v-for="sala in salas"
                v-bind:key="sala.id"
            >
                <rkm-button
                    @click="handleStore(sala)"
                    block
                    class="big-button"
                    color="primary"
                >
                    {{ sala.nome }}
                </rkm-button>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { error, repository } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    created() {
        this.repositories.chamada = this.getConectaSusRepository('prontoAtendimento.chamada')
    },
    data: () => ({
        repositories: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleStore(sala) {
            const request = {
                fila_id: this.fila.id,
                tela_id: this.tela.id,
                sala_id: sala.id,
            }

            this.setLoading()

            this.repositories.chamada.store(request)
                .then(response => {
                    this.$emit('stored', response)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [ error, repository ],
    props: {
        fila: { type: Object, required: true },
        salas: { type: Array, required: true },
        tela: { type: Object, required: true },
    }
}
</script>